import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./RecruitersGrid.css";

const recruiters5865F2 = Array.from({ length: 36 }, (_, i) => ({
  id: `rec-${i + 1}`,
  name: `Recruiter ${i + 1}`,
  logo: `/images/Placements/${i + 1}.webp`,
})).filter((_, i) => i !== 7);

const quickActions5865F2 = [
 
];

export default function RecruitersGrid() {
  return (
    <div className="rs5865f2-page">
      <div className="rs5865f2-circuitBg" aria-hidden="true" />

      <div className="rs5865f2-section">

        <div className="rs5865f2-titleWrap">
          <div className="rs5865f2-titleRow">
            <div className="rs5865f2-titlePlain">Our</div>
            <div className="rs5865f2-titleGradient">Recruiters</div>
          </div>
          <div className="rs5865f2-gradientLine" />
        </div>

        <div className="rs5865f2-subtitle">
          Join over 50+ top-tier companies that trust our Post-Graduates to build the
          future of technology, business, and innovation.
        </div>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={4}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          breakpoints={{
            640: { slidesPerView: 4, spaceBetween: 16 },
            768: { slidesPerView: 4, spaceBetween: 20 },
            1024: { slidesPerView: 5, spaceBetween: 24 },
          }}
          className="rs5865f2-swiper"
        >
          {recruiters5865F2.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="rs5865f2-card">
                <img
                  className="rs5865f2-cardLogo"
                  src={item.logo}
                  alt={item.name}
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="rs5865f2-fabRail" aria-label="Quick actions">
        {quickActions5865F2.map((a) => (
          <a
            key={a.id}
            className="rs5865f2-fabBtn"
            href={a.href}
            aria-label={a.label}
            style={{ backgroundColor: a.bg }}
          >
            <img className="rs5865f2-fabIcon" src={a.svgUrl} alt="" />
          </a>
        ))}
      </div>
    </div>
  );
}


// export default RecruitersGrid;
